export const environment = {
    production: false,
    apiBaseUrl: "https://dev-api-aod.airproducts.com/api/v1/",
    authority: 'https://login.microsoftonline.com/950af356-6025-4fdb-96a0-a9be6b893fec',
    client_id: 'ea27d003-53d1-4a3d-a37f-867f9e68c115',
    redirect_uri: 'https://dev-aod.airproducts.com/auth-callback',
    post_logout_redirect_uri: 'http://dev-aod.airproducts.com/',
    gmaps: 'AIzaSyDGFKvimiNPU2eFS7u-DUcNtpQ291u_E3o',
    mapId: '9344b8ee898c779e',
    googlemapsUrl : "https://maps.googleapis.com/maps/api/"
};
